import { billableWeight } from "./status.js";
export { billableWeight };
export function billableDays(statuses) {
    return statuses.reduce((sum, s) => sum + billableWeight(s), 0);
}
export function expectedCents(billable, tjmCents) {
    return Math.round(billable * tjmCents);
}
export function owedCents(expected, received) {
    return Math.max(0, expected - received);
}
const EUR = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
export function formatEuros(cents) {
    return EUR.format(cents / 100);
}
//# sourceMappingURL=money.js.map